// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"S0-z","sponsoredTooltipWrapper":"T0-z","sponsoredTooltip":"U0-z","newCard":"V0-z"};